"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DescriptorsContext", {
    enumerable: true,
    get: function() {
        return DescriptorsContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const DescriptorsContext = /*#__PURE__*/ (0, _react().createContext)({});

//# sourceMappingURL=descriptors-context.js.map
